import type { ListResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import { licenceQueryHttp } from '../../_shared/infrastructure/licence-query.http';
import type { ListsGateway } from './lists.gateway';

/** The real implementation. One HTTP call per method, no logic. */
export const httpListsGateway: ListsGateway = {
  fetchLists: () => api.get<ListResponse[]>('/admin/lists'),

  updateList: async (listId, patch) => {
    await api.patch(`/lists/${listId}`, patch);
  },

  deleteList: async (listId) => {
    await api.delete(`/admin/lists/${listId}`);
  },

  duplicateList: (listId, name) =>
    api.post<ListResponse>(`/admin/lists/${listId}/duplicate`, { name }),

  // ── Licence dropdown read, shared with the Add and Edit wizards ──
  ...licenceQueryHttp,
};
